const redFlags = `
### What a red flag is

A red flag is a finding the model raised from the documents that may affect whether the agency can accept the referral or how the first visit should be planned. Each flag shows its category, a severity badge, the flag name, and the evidence text it was based on. The categories depend on the workflow your agency uses.

### Severity levels

Flags sort by severity: Critical, then High, Medium, and Info. A case with an active Critical flag shows a flag icon in the case list until the flag is dismissed.

### Review each flag

The Red Flags panel shows how many flags are detected and how many you have reviewed.

- Correct confirms the flag is accurate.
- Dismiss records that the evidence does not support it.
- Click the active button again to undo.
- Mark all reviewed confirms every pending flag at once.

### The recommendation banner

When the model has produced a risk score, a banner shows a recommendation and the risk level, for example Accept (low risk), Clarify (medium risk), or Decline / Hold (high risk). It reflects the flags as the model raised them. The coordinator makes the decision.

### The flag that blocks

The Patient identity mismatch flag is the only flag that stops the workflow. It is reviewed in its own banner on the Review & Approve step, described under The review workflow.

### Identity details on a flag

Some flags list what each document says about the patient: the document name, then the name, date of birth, and MRN it carries. A missing value reads Not stated.
`;

export default redFlags;
